import { M8PartnerInfo } from 'services/production/types';
import { getM8PartnerURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { appendHeadersWithJSONContentType, customFetch } from 'utils/http';

export const addPartnerInfo = async (params: M8PartnerInfo): Promise<void> => {
  const fetchURL = getM8PartnerURL('addPartnerInfo');

  const body = JSON.stringify(params);

  const headers = new Headers();

  appendHeadersWithJSONContentType(headers);

  const response = await customFetch(fetchURL, {
    method: 'POST',
    body,
    headers,
  });

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }
};
